export const STORAGE_KEYS = {
  TOKEN: 'pd_onboarding_token',
  REFRESH_TOKEN: 'pd_onboarding_refresh_token',
  SESSION_ID: 'pd_onboarding_session_id',
} as const;
